import React from 'react';
import classes from './style.module.scss';

export interface EmptyMessageProps {
  message: string;
}

export type EmptyMessageComponent = React.FC<EmptyMessageProps>;

const EmptyMessage: EmptyMessageComponent = ({ message }) => {
  return <div className={classes['empty']}>{message}</div>;
};

export default EmptyMessage;
